import React from 'react';
import { Link } from 'react-router-dom';

const sizeMap = {
  sm: 'h-7 md:h-8',
  md: 'h-8 md:h-10',
  lg: 'h-10 md:h-12',
  xl: 'h-9 sm:h-11 md:h-12',
};

export default function Logo({ size = 'md', tone = 'brand', className = '' }) {
  return (
    <Link to="/" className={`inline-flex items-center group select-none ${className}`} aria-label="Little Splash Swim Program" data-testid="brand-logo">
      <img
        src="/logo-landscape.png"
        alt="Little Splash Swim Program"
        width="900"
        height="146"
        className={`${sizeMap[size] || sizeMap.md} w-auto transition-transform group-hover:scale-[1.02] ${tone === 'light' ? 'brightness-0 invert' : ''}`}
      />
    </Link>
  );
}
